import React, { useContext } from 'react';
import styled from 'styled-components';

import SmartRider from '../../../assets/img/smartrider.jpg';
import MyWayDriver from '../../../assets/img/mywaydriver.jpg';
import MyWay from '../../../assets/img/myway.jpg';
import MonDemoQLD from '../../../assets/img/mdemof.jpg';

import { UserContext } from '../../../contexts/UserContext';
import { DatabaseContext } from '../../../contexts/DatabaseContext';

const CardFront = () => {
  const { Site } = useContext(UserContext);
  const { apiUrl } = useContext(DatabaseContext);
  return (
    <>
      <Container
        style={{
          backgroundImage: `url(${
            Site.siteType === 2
              ? MyWayDriver
              : Site.siteType === 4
              ? MonDemoQLD
              : Site.siteType === 5
              ? MyWay
              : SmartRider
          })`,
          backgroundSize: 'cover',
        }}
      />
    </>
  );
};

const Container = styled.div`
  position: relative;
  background: #ffffff;
  color: #000000;
  border-radius: 0.8rem;
  padding-top: 62%;
  font-family: Arial, Helvetica, sans-serif;
  overflow: hidden;
`;

export default CardFront;
